/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { Button } from "react-bootstrap";
import * as actions from "../../../../../redux/actions/auth";
import { fetchImageToken } from "../../../../../redux/actions/imageAuth";
import { useEffect } from "react";
import { Link } from "react-router-dom";

export function UserProfileDropdown() {
  const { user, imageToken, imageTokenLoading } = useSelector((state) => ({
    user: state.auth.user,
    imageToken: state.imageAuth.imageToken,
    imageTokenLoading: state.imageAuth.imageTokenLoading,
  }));
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchImageToken());
  }, [dispatch]);

  const handleLogout = () => {
    dispatch(actions.logout());
  };

  return (
    <Dropdown drop="down" alignRight>
      <Dropdown.Toggle
        as={DropdownTopbarItemToggler}
        id="dropdown-toggle-user-profile"
      >
        <div
          className={
            "btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
          }
        >
          <span className="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">
            Hi,
          </span>{" "}
          <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
            {user.full_name}
          </span>
          <span className="symbol symbol-35 symbol-light-success">
            <span className="symbol-label font-size-h5 font-weight-bold">
              {imageTokenLoading ? (
                <div className="d-flex justify-content-center align-content-center">
                  <span className="mx-3 spinner spinner-primary"></span>
                </div>
              ) : (
                <img
                  alt="error"
                  style={{
                    maxWidth: "25px",
                    maxHeight: "25px",
                    cursor: "pointer",
                  }}
                  src={(user.picture) ? user.picture.formats.thumbnail.url + imageToken : ''}
                />
              )}
            </span>
          </span>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className="px-4 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround ">
        <>
          <div className="d-flex justify-content-center mt-2">
            <Link
              to="/activity"
              className="btn btn-light-primary font-weight-bold"
            >
              Activity
            </Link>
          </div>
          <div className="navi-footer d-flex justify-content-center  px-8 py-5">
            <Button
              onClick={handleLogout}
              className="btn btn-light-primary font-weight-bold"
            >
              Sign Out
            </Button>
          </div>
        </>
      </Dropdown.Menu>
    </Dropdown>
  );
}
